import { MenuItem } from "../types";
import SettingsSvg from "Assets/icons/setting.svg";
import CompanySvg from "Assets/icons/company.svg";
import MembersSvg from "Assets/icons/members.svg";
import ResourcesSvg from "Assets/icons/resources.svg";
import SecuritySvg from "Assets/icons/security.svg";
import CommunicationCentreSvg from "Assets/icons/mailer.svg";
import GeneralSvg from "Assets/icons/dashboard.svg";
import WarehousingSvg from "Assets/icons/warehousing.svg";
import BranchesSvg from "Assets/icons/branches.svg";
import AutomationSvg from "Assets/icons/automation.svg";
import ItemListSvg from "Assets/icons/item-list.svg";
import LocationSvg from "Assets/icons/location.svg";
import PackagingTypeSvg from "Assets/icons/packaging-type.svg";
import MethodPreparationSvg from "Assets/icons/method-preparation.svg";
import ModeTypeSvg from "Assets/icons/mode-type.svg";
import ExceptionCodesSvg from "Assets/icons/exception-codes.svg";
import MarkerSvg from "Assets/icons/marker.svg";
import ItemInstructionSvg from "Assets/icons/item-instruction.svg";
import ItemDestinationSvg from "Assets/icons/item-destination.svg";
import PreferencesSvg from "Assets/icons/preferences.svg";
import OperationsAppSvg from "Assets/icons/operations-app.svg";
import CurrenciesSvg from "Assets/icons/currencies.svg";
import RulerSvg from "Assets/icons/measurements.svg";
import LeadSourceSvg from "Assets/icons/lead-source.svg";
import StatusesSvg from "Assets/icons/statuses.svg";
import TasksTypesSvg from "Assets/icons/tasks-types.svg";
import LanguagesSvg from "Assets/icons/languages.svg";
import StorageBoxTypesSvg from "Assets/icons/storage-box-types.svg";
import WarehouesesSvg from "Assets/icons/warehouses.svg";
import StorageBoxesSvg from "Assets/icons/storage-boxes.svg";
import AccessRulesSvg from "Assets/icons/preferences.svg";
import GroupsSvg from "Assets/icons/operations-app.svg";
import MembersSubItemSvg from "Assets/icons/network-general.svg";
import InventorySvg from "Assets/icons/inventory.svg";
import ChecklistFormsSvg from "Assets/icons/checklist-forms.svg";
import EquipmentsSvg from "Assets/icons/equipments.svg";
import CalendarPlusSvg from "Assets/icons/calendar-plus.svg";
import AccessSvg from "Assets/icons/access.svg";
import MaterialsSvg from "Assets/icons/materials.svg";
import BrandingSvg from "Assets/icons/branding.svg";
import LegalSvg from "Assets/icons/legal.svg";
import BillingSvg from "Assets/icons/credit-card.svg";
import ServicesTariffsSvg from "Assets/icons/dolar-icon.svg";
import BookingsSvg from "Assets/icons/calendar-check.svg";
import CarriersSvg from "Assets/icons/box-carriers.svg";
import PortsSvg from "Assets/img/boat-icon.svg";
import ConfigurationsSvg from "Assets/icons/switch-buttons.svg";
import SalesAppSvg from "Assets/icons/sales-app.svg";
import OrderTypeSvg from "Assets/icons/network-general.svg";
import IntegrationsSvg from "Assets/icons/integrations.svg";
import NetworkSvg from "Assets/icons/new-network.svg";
import MilitaryBadgeSvg from "Assets/icons/military-badge.svg";

import { ResourcePageEnum } from "Util/enums/resourcePage";
import { InventoryPageEnum } from "Util/enums/inventoryPage";
import { WarehousePageEnum } from "Util/enums/warehouse";
import { GeneralPageEnum } from "Util/enums/general";

export const menuConfigSettings: MenuItem[] = [
  {
    key: "settings",
    label: "settings",
    ui: "drawer",
    icon: SettingsSvg,
    sectionTitle: "SETTINGS",
    children: [
      {
        key: "general",
        label: "general",
        icon: GeneralSvg,
        children: [
          {
            key: "company",
            label: "company",
            icon: CompanySvg,
            path: "/app/settings",
            state: { tabKey: "company" },
          },
          { key: "branding", label: "branding", icon: BrandingSvg, path: "/app/branding" },
          { key: "legal", label: "legal", icon: LegalSvg, path: "/app/legal" },
          {
            key: "security",
            label: "security",
            icon: SecuritySvg,
            path: "/app/settings",
            state: { tabKey: "security" },
          },
          { key: "billing", label: "billing", icon: BillingSvg, path: "/app/billing" },
        ],
      },
      {
        key: "members",
        label: "members",
        icon: MembersSvg,
        children: [
          {
            key: "access-rules",
            label: "accessRules",
            icon: AccessRulesSvg,
            path: "/app/settings",
            state: { tabKey: "people", subTabKey: "accessRules" },
          },
          {
            key: "groups",
            label: "groups",
            icon: GroupsSvg,
            path: "/app/settings",
            state: { tabKey: "people", subTabKey: "groups" },
          },
          {
            key: "members-children",
            label: "members",
            icon: MembersSubItemSvg,
            path: "/app/settings",
            state: { tabKey: "people", subTabKey: "members" },
          },
        ],
      },
      {
        key: "localization",
        label: "localization",
        icon: MarkerSvg,
        children: [
          {
            key: "languages",
            label: "languages",
            icon: LanguagesSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "general",
              subSubTabKey: GeneralPageEnum.LANGUAGES,
            },
          },
          {
            key: "currencies",
            label: "currencies",
            icon: CurrenciesSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "general",
              subSubTabKey: GeneralPageEnum.CURRENCIES,
            },
          },
          {
            key: "unit-system",
            label: "unitSystem",
            icon: RulerSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "general",
              subSubTabKey: GeneralPageEnum.MEASUREMENTS,
            },
          },
        ],
      },
      {
        key: "communicationcentre",
        label: "communicationCentre",
        icon: CommunicationCentreSvg,
        path: "/app/settings",
        state: {
          tabKey: "communicationcentre",
        },
      },
      {
        key: "resources",
        label: "resources",
        icon: ResourcesSvg,
        children: [
          {
            key: "checklist-forms",
            label: "checklistForms",
            icon: ChecklistFormsSvg,
            path: "/app/settings",
            state: { tabKey: "resources", subTabKey: ResourcePageEnum.CHECKLIST },
          },
          {
            key: "equipments",
            label: "equipments",
            icon: EquipmentsSvg,
            path: "/app/settings",
            state: { tabKey: "resources", subTabKey: ResourcePageEnum.EQUIPMENTS },
          },
          {
            key: "services-tariffs",
            label: "servicesAndTariffs",
            icon: ServicesTariffsSvg,
            path: "/app/settings",
            state: { tabKey: "resources", subTabKey: ResourcePageEnum.SERVICES },
          },
          {
            key: "instructions",
            label: "instructions",
            icon: CalendarPlusSvg,
            path: "/app/settings",
            state: { tabKey: "resources", subTabKey: ResourcePageEnum.INSTRUCTIONS },
          },
          {
            key: "access",
            label: "access",
            icon: AccessSvg,
            path: "/app/settings",
            state: { tabKey: "resources", subTabKey: ResourcePageEnum.ACCESS },
          },
          {
            key: "materials",
            label: "materials",
            icon: MaterialsSvg,
            path: "/app/settings",
            state: { tabKey: "resources", subTabKey: ResourcePageEnum.MATERIAL },
          },
          {
            key: "inventory",
            label: "inventory",
            ui: "third-drawer",
            icon: InventorySvg,
            sectionTitle: "INVENTORY",
            children: [
              {
                key: "item-list",
                label: "itemList",
                icon: ItemListSvg,
                path: "/app/settings",
                state: {
                  tabKey: "resources",
                  subTabKey: ResourcePageEnum.INVENTORY,
                  subSubTabKey: InventoryPageEnum.ITEM,
                },
              },
              {
                key: "location",
                label: "location",
                icon: LocationSvg,
                path: "/app/settings",
                state: {
                  tabKey: "resources",
                  subTabKey: ResourcePageEnum.INVENTORY,
                  subSubTabKey: InventoryPageEnum.LOCATION,
                },
              },
              {
                key: "package-type",
                label: "packageType",
                icon: PackagingTypeSvg,
                path: "/app/settings",
                state: {
                  tabKey: "resources",
                  subTabKey: ResourcePageEnum.INVENTORY,
                  subSubTabKey: InventoryPageEnum.PACKAGING,
                },
              },
              {
                key: "method-preparation",
                label: "methodOfPreparation",
                icon: MethodPreparationSvg,
                path: "/app/settings",
                state: {
                  tabKey: "resources",
                  subTabKey: ResourcePageEnum.INVENTORY,
                  subSubTabKey: InventoryPageEnum.PREPARATION,
                },
              },
              {
                key: "mode-type",
                label: "modeType",
                icon: ModeTypeSvg,
                path: "/app/settings",
                state: {
                  tabKey: "resources",
                  subTabKey: ResourcePageEnum.INVENTORY,
                  subSubTabKey: InventoryPageEnum.MODE,
                },
              },
              {
                key: "exception-codes",
                label: "exceptionCodes",
                icon: ExceptionCodesSvg,
                path: "/app/settings",
                state: {
                  tabKey: "resources",
                  subTabKey: ResourcePageEnum.INVENTORY,
                  subSubTabKey: InventoryPageEnum.EXCEPTION,
                },
              },
              {
                key: "exception-location-code",
                label: "exceptionLocationCode",
                icon: MarkerSvg,
                path: "/app/settings",
                state: {
                  tabKey: "resources",
                  subTabKey: ResourcePageEnum.INVENTORY,
                  subSubTabKey: InventoryPageEnum.EXCEPTION_LOCATION,
                },
              },
              {
                key: "item-instruction",
                label: "itemInstruction",
                icon: ItemInstructionSvg,
                path: "/app/settings",
                state: {
                  tabKey: "resources",
                  subTabKey: ResourcePageEnum.INVENTORY,
                  subSubTabKey: InventoryPageEnum.SPECIAL_INSTRUCTIONS,
                },
              },
              {
                key: "item-destination",
                label: "itemDestination",
                icon: ItemDestinationSvg,
                path: "/app/settings",
                state: {
                  tabKey: "resources",
                  subTabKey: ResourcePageEnum.INVENTORY,
                  subSubTabKey: InventoryPageEnum.DESTINATION,
                },
              },
            ],
          },
        ],
      },
      {
        key: "warehousing",
        label: "warehousing",
        icon: WarehousingSvg,
        children: [
          {
            key: "branches",
            label: "branches",
            icon: BranchesSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "branches",
            },
          },
          {
            key: "warehouses",
            label: "warehouses",
            icon: WarehouesesSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "warehousing",
              subSubTabKey: WarehousePageEnum.WAREHOUSES,
            },
          },
          {
            key: "storage-box-types",
            label: "storageBoxTypes",
            icon: StorageBoxTypesSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "warehousing",
              subSubTabKey: WarehousePageEnum.STORAGE_BOX_TYPES,
            },
          },
          {
            key: "storage-boxes",
            label: "storageBoxes",
            icon: StorageBoxesSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "warehousing",
              subSubTabKey: WarehousePageEnum.STORAGE_BOXES,
            },
          },
        ],
      },
      {
        key: "bookings",
        label: "bookings",
        icon: BookingsSvg,
        children: [
          {
            key: "carriers",
            label: "carriers",
            icon: CarriersSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "general",
              subSubTabKey: GeneralPageEnum.CARRIERS,
            },
          },
          {
            key: "ports",
            label: "ports",
            icon: PortsSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "ports",
            },
          },
          {
            key: "hsCommodityCode",
            label: "hsCommodityCode",
            icon: CalendarPlusSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "hsCommodityCode",
            },
          },
        ],
      },
      {
        key: "configurations",
        label: "configurations",
        icon: ConfigurationsSvg,
        children: [
          {
            key: "preferences",
            label: "preferences",
            icon: PreferencesSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "general",
              subSubTabKey: GeneralPageEnum.PREFERENCES,
            },
          },
          {
            key: "sales-app",
            label: "salesApp",
            icon: SalesAppSvg,
            path: "/app/sales-app",
          },
          {
            key: "operations-app",
            label: "operationsApp",
            icon: OperationsAppSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "general",
              subSubTabKey: GeneralPageEnum.OPERATIONS_APP,
            },
          },
          {
            key: "network",
            label: "network",
            icon: NetworkSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "general",
              subSubTabKey: GeneralPageEnum.NETWORK,
            },
          },
          {
            key: "order-type",
            label: "orderType",
            icon: OrderTypeSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "general",
              subSubTabKey: GeneralPageEnum.ORDER_TYPE,
            },
          },
          {
            key: "tasks-type",
            label: "tasksType",
            icon: TasksTypesSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "general",
              subSubTabKey: GeneralPageEnum.TASK_TYPE,
            },
          },
          {
            key: "lead-source",
            label: "leadSource",
            icon: LeadSourceSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "general",
              subSubTabKey: GeneralPageEnum.LEAD_SOURCE,
            },
          },
          {
            key: "statuses",
            label: "statuses",
            icon: StatusesSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "general",
              subSubTabKey: GeneralPageEnum.STATUS,
            },
          },
          {
            key: "automation",
            label: "automation",
            icon: AutomationSvg,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "automation",
            },
          },
          {
            key: "military",
            label: "Military",
            icon: MilitaryBadgeSvg,
            militaryOnly: true,
            path: "/app/settings",
            state: {
              tabKey: "configurations",
              subTabKey: "general",
              subSubTabKey: GeneralPageEnum.MILITARY,
            },
          },
        ],
      },
      {
        key: "integrations",
        label: "integrations",
        icon: IntegrationsSvg,
        path: "/app/integrations",
      },
    ],
  },
];
